import { RootState } from '../reducers';

export const errorSelector = (state: RootState) => state.errorReducer;

export const errorKeysSelector = (state: RootState) => errorSelector(state).errorKeys;
